export default __webpack_public_path__ + "static/media/repair_shops_city_map.f4403b04.png";